import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';

const StyledTabIndicator = styled.div`
    position: absolute;
    height: .3rem;
    top: 0;
    left: 0;
    right: 0;
    background-color: ${ (props) => {
        const { active, error } = props;

        const states = {
            active: theme.palette.primary1Color,
            inactive: 'transparant',
            error: theme.palette.tomato,
        };

        if (!active) {

            // Active: false - Error: true.
            if (error) {
                return states.error;
            }

            // Active false - Error: false.
            return states.inactive;
        }

        // Assume the tab is active.
        return states.active;
    } };
`;

const TabIndicator = (props) => {
    const { active, error } = props;

    return <StyledTabIndicator active={ active } error={ error } />;
};

TabIndicator.propTypes = {
    active: PropTypes.bool,
    error: PropTypes.bool,
};

export default TabIndicator;



// WEBPACK FOOTER //
// ./src/components/tabs/tab/TabIndicator.js